import React from 'react';
import { Edit, Trash2, UserCheck } from 'lucide-react';
import EmptyState from '../Common/EmptyState';
import Can from '../Common/Can';
import { P } from '../../constants/permissions';

const TechnicalResponsibleTable = ({ responsibles, isLoading, onEdit, onDelete, onCreate }) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!responsibles?.length) {
    return (
      <EmptyState
        icon={UserCheck}
        title="Nenhum responsável técnico encontrado"
        description="Cadastre responsáveis técnicos vinculados a licenças e processos."
        action={
          onCreate ? (
            <Can permission={P.PROFESSIONAL_ACCESS}>
              <button type="button" className="btn btn-primary" onClick={onCreate}>
                Novo responsável
              </button>
            </Can>
          ) : null
        }
      />
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nome</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Registro</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Conselho</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {responsibles.map((responsible) => (
            <tr key={responsible.id} className="hover:bg-gray-50">
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm font-medium text-gray-900">{responsible.name}</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <div className="text-sm text-gray-900">{responsible.registration_number}</div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-primary-100 text-primary-700">
                  {responsible.council}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                  responsible.status === 'ACTIVE' 
                    ? 'bg-success-100 text-success-700' 
                    : 'bg-gray-100 text-gray-700'
                }`}>
                  {responsible.status === 'ACTIVE' ? 'Ativo' : 'Inativo'}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                <Can permission={P.PROFESSIONAL_ACCESS}>
                  <div className="flex justify-end gap-2">
                    <button type="button" onClick={() => onEdit(responsible)} className="text-primary-600 hover:text-primary-900">
                      <Edit className="w-4 h-4" />
                    </button>
                    <button type="button" onClick={() => onDelete(responsible.id)} className="text-red-600 hover:text-red-900">
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </Can>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TechnicalResponsibleTable;